import React from 'react';
import SettingsLayout from './SettingsLayout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import MyTemplatesTab from '../../components/sharing/MyTemplatesTab';
import MySignaturesTab from '../../components/sharing/MySignaturesTab';

/**
 * Settings → Templates & Signatures (#955) — open to every signed-in role.
 *
 * A user's own email templates and signatures, the ones shared with them, and
 * the organisation's (read-only here; admins manage those under Admin). Items
 * can be kept private or shared with chosen people and groups; only the owner
 * edits or deletes, everyone else can make a private copy.
 */
export default function SettingsTemplatesSignaturesPage() {
    return (
        <SettingsLayout
            title="Templates & Signatures"
            description="Manage your email templates and signatures, and share them with your team"
        >
            <Tabs defaultValue="templates" className="max-w-3xl">
                <TabsList>
                    <TabsTrigger value="templates" data-testid="tab-templates">Email templates</TabsTrigger>
                    <TabsTrigger value="signatures" data-testid="tab-signatures">Signatures</TabsTrigger>
                </TabsList>
                <TabsContent value="templates" className="pt-4">
                    <MyTemplatesTab />
                </TabsContent>
                <TabsContent value="signatures" className="pt-4">
                    <MySignaturesTab />
                </TabsContent>
            </Tabs>
        </SettingsLayout>
    );
}
